import { FAQ_ALL_OPTION, type FaqOption } from '../constants/faq.ts';

interface BoardCategoryTabsProps {
  options: readonly FaqOption[];
  value: string | null;
  onChange: (value: string | null) => void;
  /** 탭 목록 이름 (스크린리더용) */
  ariaLabel?: string;
}

const TAB_CLASS = {
  base: "relative -mb-px inline-flex h-12 min-w-[112px] flex-1 items-center justify-center whitespace-nowrap rounded-t-md border px-4 text-[14px] font-semibold transition-colors after:absolute after:inset-x-5 after:top-0 after:h-0.5 after:rounded-full after:content-['']",
  active:
    'z-10 border-black/20 border-b-white bg-white text-neutral-950 shadow-[0_-1px_0_rgba(0,0,0,0.03)] after:bg-[#FA0F00] dark:border-white/20 dark:border-b-dark-base dark:bg-dark-base dark:text-white',
  // 안 고른 탭도 가장자리를 옅게 그려 탭 칸이 보이게 한다 (아래는 목록 밑줄이 맡는다)
  inactive:
    'border-black/[0.08] border-b-transparent bg-transparent dark:border-white/10 dark:border-b-transparent text-neutral-950/45 after:bg-transparent hover:bg-white/70 hover:text-neutral-950 dark:text-white/45 dark:hover:bg-white/5 dark:hover:text-white',
} as const;

export function BoardCategoryTabs({
  options,
  value,
  onChange,
  ariaLabel = '분류',
}: BoardCategoryTabsProps) {
  return (
    <div className="overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div
        role="tablist"
        aria-label={ariaLabel}
        className="flex w-full min-w-[640px] items-end gap-0.5 border-b border-black/20 bg-neutral-50/40 px-1 pt-1.5 dark:border-white/20 dark:bg-white/[0.015]"
      >
        {[FAQ_ALL_OPTION, ...options].map((option) => {
          const isActive = value === option.value;
          return (
            <button
              key={option.value ?? FAQ_ALL_OPTION.label}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(option.value)}
              className={`${TAB_CLASS.base} ${
                isActive ? TAB_CLASS.active : TAB_CLASS.inactive
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
